import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=4dc7dbda&scoped=true"
import script from "./terminal.vue?vue&type=script&lang=js"
export * from "./terminal.vue?vue&type=script&lang=js"
import style0 from "./terminal.vue?vue&type=style&index=0&id=4dc7dbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7dbda",
  null
  
)

export default component.exports